import React from 'react';

import Markup from '../../markup';

function Warning({ text, isVisible }: { text: string; isVisible: boolean }) {
    return (
      <Markup.Global.Text.WarningContainer isVisible={isVisible}>
        <Markup.Global.Text.Warning >
          {text}
        </Markup.Global.Text.Warning>
      </Markup.Global.Text.WarningContainer>
    );
  }

export default React.memo(Warning);
